import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SuperAdminRoute = () => {
  const { user, isAuthenticated, loading, defaultHomeRoute } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-rose-100">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-t-transparent rounded-full animate-spin" style={{ borderColor: '#f43f5e', borderTopColor: 'transparent' }} />
          <span className="text-sm tracking-wide">Validating super admin authority...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.role !== 'super_admin') return <Navigate to={defaultHomeRoute || '/dashboard'} replace />;

  return <Outlet />;
};

export default SuperAdminRoute;
